import actions from '@/store/modules/home/actions'
import getters from '@/store/modules/home/getters'
import mutations from '@/store/modules/home/mutations'
import state from '@/store/modules/home/state'

export default {
    actions,
    getters,
    mutations,
    state
}